import { cva } from 'class-variance-authority';
import { cn } from '../../common/functions/cn';

export const toggleVariants = cva(
  cn(
    'group/toggle inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md border font-medium text-sm outline-none transition-[color,background-color,box-shadow]',
    'hover:bg-muted hover:text-foreground',
    'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50',
    'disabled:pointer-events-none disabled:opacity-50',
    'aria-invalid:border-error aria-invalid:ring-error/20 dark:aria-invalid:ring-error/40',
    'aria-pressed:bg-accent aria-pressed:text-accent-foreground',
    "[&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0"
  ),
  {
    variants: {
      variant: {
        default: 'border-transparent bg-transparent',
        outline: 'border-border bg-transparent hover:bg-muted',
      },
      size: {
        default: cn('h-8 min-w-8 text-sm', 'px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2'),
        sm: cn(
          'h-7 min-w-7 text-sm',
          "px-2.5 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5"
        ),
        lg: cn('h-9 min-w-9 text-sm', 'px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2'),
        'icon-sm': 'size-7 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
